import { Result as ResultAD } from 'antd';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

type P = ComponentProps<typeof ResultAD>;

const Result = ({ subTitle, ...rest }: P) => {
  const { t } = useTranslation();

  return <ResultAD subTitle={typeof subTitle === 'string' ? t(subTitle) : subTitle} {...rest} />;
};

export default Result;
